import Header from "../../components/Header";
import AdminSideBar from "../../components/AdminSideBar";
import { ProSidebarProvider } from "react-pro-sidebar";
import { Spinner } from "react-bootstrap";

const AdminLayout = ({ children, isLoading }) => {
  return (
    <>
      <Header />
      <div className="d-flex">
        <ProSidebarProvider>
          <AdminSideBar />
        </ProSidebarProvider>
        <div className="home-page w-100">
           {/* {isLoading && <Spinner animation="border" variant="warning" className="spinner" />} */}
          {children}
        </div>
      </div>
    </>
  );
};

export default AdminLayout;